import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Affix, Button, Skeleton, Modal } from 'antd';
import {
  getTemplateById,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from '../../redux/actions/templateCard';
import { interfaceActions } from '../../../../common/redux/actions';
import FormTemplateCard from '../../components/TemplateCard/FormTemplateCard';
import FormProgress from '../../components/FormProgress/FormProgress';
import BtnCloseEditing from '../../components/TemplateCard/buttons/BtnCloseEditing';
import BtnFormSubmit from '../../components/TemplateCard/buttons/BtnFormSubmit';
import history from '../../../../common/history';
import progresses from '../../components/FormProgress/progresses';
import { confirmDelete } from '../../components/TemplateCard/popup/confirm';
import * as URLs from '../../../../common/constants/systemUrls';
const { setCaption } = interfaceActions;
const confirm = Modal.confirm;

class TemplateCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      formProgress: [...progresses.default],
      templateId: this.getTemplateId(),
    };
    if (this.state.templateId === 0) {
      this.state.isEditable = true;
    }
    this.forms = {};
  }
  componentDidMount() {
    this.setCaption(true);
    if (this.state.templateId > 0) {
      this.props.getTemplateById(this.state.templateId);
    }
  }

  componentDidUpdate(prevProps, _prevState) {
    this.updateTemplateId(); // Смотрим не сменился ли templateId
    this.setCaption(this.props.data !== prevProps.data && this.props.data);
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = '';
      let breadCrumbs = null;
      if (this.state.templateId === 0) {
        title = 'Создание шаблона предложения';
      } else {
        const { data } = this.props;
        if (data) {
          title = data.name;
          if (this.state.isEditable) {
            breadCrumbs = title;
            title = 'Редактирование шаблона';
          }
        }
      }

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: '/' + URLs.CONTROL_PANEL,
              breadcrumbName: 'Панель управления',
            },
            {
              path: '/' + URLs.SYSTEM_SETTINGS + '/templates',
              breadcrumbName: 'Настройки системы - Шаблоны',
            },
            {
              path: '/' + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title,
            },
          ],
        });
      }
    }
  }

  updateTemplateId() {
    const templateId = this.getTemplateId();
    if (templateId !== this.state.templateId) {
      if (templateId > 0) {
        this.props.getTemplateById(templateId);
      }
      this.setState(state => ({
        templateId,
        isEditable: templateId === 0 ? true : state.isEditable,
      }));
    }
  }

  deleteTamplate = () => {
    const { templateId } = this.state;
    confirm({
      ...confirmDelete,
      onOk: () => {
        this.props.deleteTemplate(templateId);
      },
    });
  };

  handleClickClose = () => {
    history.push('/' + URLs.SYSTEM_SETTINGS + '/templates');
  };

  handleSubmit = () => {
    this.formSubmit('formTemplateCard', fieldsValue => {
      const { templateId } = this.state;
      let data = {
        type: 'template', // есть еще order и offer (если стоит template, то после успешного добавления идёт перенаправление на главную списка шаблонов)
        templateId,
        ...fieldsValue,
      };
      if (templateId === 0) {
        this.props.createTemplate(data);
      } else {
        this.props.updateTemplate(data);
      }
    });
  };

  /* todo то что можно вынести в общие компоненты */
  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        // console.log(err, fieldsValue);
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log('Error', name);
    }
  };

  getTemplateId() {
    let { id = 0 } = this.props.match && this.props.match.params;
    id = Number(id);
    return id > 0 ? id : 0;
  }

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };
  // Обновление прогресса заполнения
  updateProgress = values => {
    const form = this.getForm('formTemplateCard');
    if (form) {
      let newFormProgress = null;
      let checkAll = true;
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress)
              newFormProgress = [...this.state.formProgress];
            newFormProgress = [
              ...newFormProgress.slice(0, index),
              {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue,
              },
              ...newFormProgress.slice(index + 1),
            ];
            if (checkAll && !check) {
              if (step.button !== false) checkAll = false;
            }
          }
        });
      });

      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }
        this.setState({
          formProgress: newFormProgress,
          disabledSaveButton: !checkAll,
        });
      }
    }
  };

  handleClickEdit = () => {
    this.setState(
      state => ({
        isEditable: true,
      }),
      () => {
        this.setCaption(true);
      }
    );
  };

  render() {
    const { isEditable } = this.state;
    const { data, isLoading } = this.props;
    const typeForm =
      this.state.templateId > 0 ? (isEditable ? 'edit' : 'view') : 'create';
    return (
      <div className="basicForm">
        <Row>
          <Col span={18} className="offer-card__form">
            {isLoading ? (
              <Skeleton active />
            ) : (
              <FormTemplateCard
                name="formTemplateCard"
                setForm={this.setForm}
                data={data}
                templateId={this.state.templateId}
                // createErrors={createErrors}
                // clearError={clearError}
                updateProgress={this.updateProgress}
                isEditable={this.state.isEditable}
                formProgress={this.state.formProgress}
              />
            )}
          </Col>
          <Col span={6} className="offer-card__status order-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById('mainSheet')}
            >
              <React.Fragment>
                {typeForm === 'view' ? (
                  <Fragment>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      onClick={this.handleClickEdit}
                    >
                      Редактировать
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      ghost
                      style={{
                        color: '#f5222d',
                        backgroundColor: '#ffffff',
                        borderColor: '#f5222d',
                      }}
                      onClick={this.deleteTamplate}
                    >
                      Удалить шаблон
                    </Button>
                  </Fragment>
                ) : (
                  <Fragment>
                    <BtnFormSubmit
                      disabled={this.state.disabledSaveButton}
                      onClick={this.handleSubmit}
                      typeForm={typeForm}
                    />
                    <div className="create-offer__progress">
                      <FormProgress progress={this.state.formProgress} />
                    </div>
                    <div className="orderCard__btn-close">
                      <BtnCloseEditing handleClick={this.handleClickClose} />
                    </div>
                  </Fragment>
                )}
              </React.Fragment>
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}
export default connect(
  state => ({
    data: state.Templates.TemplateCard.templateData,
    isLoading: state.Templates.TemplateCard.templateLoading,
  }),
  {
    getTemplateById,
    createTemplate,
    updateTemplate,
    deleteTemplate,
    setCaption,
  }
)(TemplateCard);
